interface Props {
    title: string;
    children: React.ReactNode;
    description?: string;
}

export default function ViewSection({ title, children, description, }: Props) {
    return (
        <section className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
            {/* Section Header */}
            <div className="border-b border-[#186cb2]/20 bg-[#186cb2]/10 px-4 py-3 sm:px-5">
                <h3 className="text-xs font-semibold text-gray-800 sm:text-sm">
                    {title}
                </h3>
                {description && (
                    <p className="mt-0.5 text-[10px] text-gray-500 sm:text-xs">
                        {description}
                    </p>
                )}
            </div>
            {/* Section Content */}
            <div className="p-3 sm:p-4">
                {children}
            </div>
        </section>
    )
}
